const filters = {
    //格式化字节 向下取整
    formatByte: function(bytes) {
        if (bytes == 0) { return 0 + 'Bytes'; } else if (!bytes) {
            return '';
        }
        if (bytes < 0) {
            return "Unlimited";
        } else if (bytes < 1024) {
            return Math.ceil(Math.round(bytes)) + "Bytes";
        } else if (bytes < 1024 * 1024) {
            return Math.round(bytes / 1024 * 100) / 100 + "KB";
        } else if (bytes < 1024 * 1024 * 1024) {
            return Math.round(bytes / 1024 / 1024 * 100) / 100 + "MB";
        } else if (bytes < 1024 * 1024 * 1024 * 1024) {
            return Math.round(bytes / 1024 / 1024 / 1024 * 100) / 100 + "GB";
        } else if (bytes < 1024 * 1024 * 1024 * 1024 * 1024) {
            return Math.round(bytes / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "TB";
        } else if (bytes < 1024 * 1024 * 1024 * 1024 * 1024 * 1024) {
            return Math.round(bytes / 1024 / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "PB";
        } else {
            return Math.round(bytes / 1024 / 1024 / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "EB";
        }
    },
        //格式化日志字节 向下取整
        formatLogByte: function(bytes) {
            if (bytes == 0) { return 0 + 'Bytes'; } else if (!bytes) {
                return 0 + 'Bytes';
            }
            if (bytes < 0) {
                return "Unlimited";
            } else if (bytes < 1024) {
                return Math.ceil(Math.round(bytes)) + "Bytes";
            } else if (bytes < 1024 * 1024) {
                return Math.round(bytes / 1024 * 100) / 100 + "KB";
            } else if (bytes < 1024 * 1024 * 1024) {
                return Math.round(bytes / 1024 / 1024 * 100) / 100 + "MB";
            } else if (bytes < 1024 * 1024 * 1024 * 1024) {
                return Math.round(bytes / 1024 / 1024 / 1024 * 100) / 100 + "GB";
            } else if (bytes < 1024 * 1024 * 1024 * 1024 * 1024) {
                return Math.round(bytes / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "TB";
            } else if (bytes < 1024 * 1024 * 1024 * 1024 * 1024 * 1024) {
                return Math.round(bytes / 1024 / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "PB";
            } else {
                return Math.round(bytes / 1024 / 1024 / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "EB";
            }
        },
        //格式化日志字节 向下取整,对于GB特殊处理，9999GB以上才需要转换TB
        formatByteForBanner: function(bytes) {
            if (bytes == 0) { return 0 + 'Bytes'; } else if (!bytes) {
                return 0 + 'Bytes';
            }
            if (bytes < 0) {
                return "Unlimited";
            } else if (bytes < 1024) {
                return Math.ceil(Math.round(bytes)) + "Bytes";
            } else if (bytes < 1024 * 1024) {
                return Math.round(bytes / 1024 * 100) / 100 + "KB";
            } else if (bytes < 1024 * 1024 * 1024) {
                return Math.round(bytes / 1024 / 1024 * 100) / 100 + "MB";
            } else if (bytes <= 1024 * 1024 * 1024 * 9999) {
                return Math.round(bytes / 1024 / 1024 / 1024 * 100) / 100 + "GB";
            } else if (bytes < 1024 * 1024 * 1024 * 1024 * 1024) {
                return Math.round(bytes / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "TB";
            } else if (bytes < 1024 * 1024 * 1024 * 1024 * 1024 * 1024) {
                return Math.round(bytes / 1024 / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "PB";
            } else {
                return Math.round(bytes / 1024 / 1024 / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "EB";
            }
        },
    //格式化字节全部转为GB
    formatByteToGB: function(bytes) {
        if (bytes < 0) {
            return "Unknown";
        } else {
            return Math.floor(bytes / 1024 / 1024 / 1024 * 100) / 100 + "GB";
        }
    },
    //将其他单位的格式化为字节
    convertToByte: function(value) {
        if (value == undefined) {
            return "Unknown";
        } else if (value.indexOf("Bytes") >= 0) {
            return value.replace('Bytes', '');
        } else if (value.indexOf("KB") >= 0) {
            return value.replace('KB', '') * 1024;
        } else if (value.indexOf("MB") >= 0) {
            return value.replace('MB', '') * 1024 * 1024;
        } else if (value.indexOf("GB") >= 0) {
            return (value.replace('GB', '')) * 1024 * 1024 * 1024;
        } else if (value.indexOf("TB") >= 0) {
            return value.replace('TB', '') * 1024 * 1024 * 1024 * 1024;
        } else if (value.indexOf("PB") >= 0) {
            return value.replace('PB', '') * 1024 * 1024 * 1024 * 1024 * 1024;
        } else if (value.indexOf("EB") >= 0) {
            return value.replace('EB', '') * 1024 * 1024 * 1024 * 1024 * 1024 * 1024;
        }
    },
    formatByteSpeed: function(bytes) {
        if (bytes == 0) { return 0 + 'Bytes'; } else if (!bytes) {
            return 0;
        }
        if (bytes < 0) {
            return 0;
        } else if (bytes < 1024) {
            return Math.floor(bytes) + "Bytes/s";
        } else if (bytes < 1024 * 1024) {
            return Math.floor(bytes / 1024 * 100) / 100 + "KB/s";
        } else if (bytes < 1024 * 1024 * 1024) {
            return Math.floor(bytes / 1024 / 1024 * 100) / 100 + "MB/s";
        } else if (bytes < 1024 * 1024 * 1024 * 1024) {
            return Math.floor(bytes / 1024 / 1024 / 1024 * 100) / 100 + "GB/s";
        } else if (bytes < 1024 * 1024 * 1024 * 1024 * 1024) {
            return Math.floor(bytes / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "TB/s";
        } else if (bytes < 1024 * 1024 * 1024 * 1024 * 1024 * 1024) {
            return Math.floor(bytes / 1024 / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "PB/s";
        } else {
            return Math.floor(bytes / 1024 / 1024 / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "EB/s";
        }
    },
    //将数字类型的时间转换为英文格式 
    transferTime: function(cTime) {
        if (!cTime) return '';
        var dt = new Date(cTime*1);
        var m = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Spt", "Oct", "Nov", "Dec");
        let mn = dt.getMonth();
        let dn = dt.getDate();
        let hh = dt.getHours();
        let mm = dt.getMinutes();
        if (hh < 10) {
            hh = '0' + hh;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        let newDate = m[mn] + " " + dn + " " + dt.getFullYear() + "  " + hh + ":" + mm;
        return newDate;
    },
     //将文件平铺列表数字类型的时间转换为英文格式 
     transferFilesTime: function(cTime) {
        if (!cTime) return '';
        let newDate;
        var dt = new Date(cTime);
        var m = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Spt", "Oct", "Nov", "Dec");
        let mn = dt.getMonth();
        let dn = dt.getDate();
        let hh = dt.getHours();
        let mm = dt.getMinutes();
        if (hh < 10) {
            hh = '0' + hh;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        var nowYear = new Date().getFullYear();
        if(nowYear == dt.getFullYear()){
            newDate=m[mn] + " " + dn+", "+hh + ":" + mm;
        }else{
            newDate = m[mn] + " " + dn + ", " + dt.getFullYear();
        }
        return newDate;
    },
    getCatalog(item) {
        let nodesArr = item;
        let catelog;
        if (nodesArr && nodesArr.length >= 2 &&nodesArr[0].fileId  && nodesArr[0].fileId == nodesArr[1].fileId) {
            nodesArr.splice(0, 1);
        }
        if (nodesArr) {
            for (let i = nodesArr.length - 1; i >= 0; i--) {
                if (catelog) {
                    if (nodesArr[i].fileName) {
                        catelog = catelog + '\\' + nodesArr[i].fileName;
                    } else if(nodesArr[i].filename){
                        catelog = catelog + '\\' + nodesArr[i].filename;
                    }else{
                        catelog = catelog + '\\' + nodesArr[i].name;
                    }
                } else {
                    if (nodesArr[i].fileName) {
                        catelog = nodesArr[i].fileName;
                    } else if(nodesArr[i].filename){
                        catelog = nodesArr[i].filename;
                    }else{
                        catelog = nodesArr[i].name;
                    }
                }
            }
        }
        return catelog;
    },
    getBackupInfo(item){
      return item+' and more';
    },
    getBusinessTransferCatalog(value){
        //返回根目录的nodes
        var name = value[value.length-1];
        var catalog;
        if(name.fileName){
            catalog=name.fileName;
        }
        if(name.filename){
            catalog=name.filename;
        }
        return catalog;
      },
    //获取名称
    getItemName(item) {
        if(item.filename) {
            return item.filename;
        }else if(item.fileName) {
            return item.fileName;
        }else if(item.name) {
            return item.name;
        }else {
            return "";
        }
    },
    //分享用拼装路径-不包括分享文件之前的路径
    getCatalogShare(item) {
        let nodesArr = item;
        let catelog;
        if (nodesArr && nodesArr.length >= 2 && nodesArr[0].fileId == nodesArr[1].fileId) {
            nodesArr.splice(0, 1);
        }
        if (nodesArr) {
            //传输文件本身附加cryptId
            nodesArr[0].cryptId = nodesArr[0].fileId
            for (let i = nodesArr.length - 1; i >= 0; i--) {
                if(nodesArr[i].cryptId&&nodesArr[i].cryptId!=="null"){
                    if (catelog) {
                        if (nodesArr[i].fileName) {
                            catelog = catelog + '\\' + nodesArr[i].fileName;
                        } else {
                            catelog = catelog + '\\' + nodesArr[i].filename;
                        }
                    } else {
                        if (nodesArr[i].fileName) {
                            catelog = nodesArr[i].fileName;
                        } else {
                            catelog = nodesArr[i].filename;
                        }
                    }
                }
            }
        }
        return catelog;
    },
    getCatalogTitle(catelog) {
        let length;
        let strArr = [];
        let catelogAll;
        if (catelog && catelog.length > 60) {
            length = Math.ceil(catelog.length / 60);
            for (let i = 1; i <= length; i++) {
                let str;
                if (i == 1) {
                    str = catelog.slice(0, i * 60);
                } else {
                    str = catelog.slice((i - 1) * 60, i * 60);
                }
                strArr.push(str);
            }
            for (let j = 0; j < strArr.length; j++) {
                if (j == 0) {
                    catelogAll = strArr[j];
                } else {
                    catelogAll = catelogAll + '\n' + strArr[j];
                }
            }
        } else {
            catelogAll = catelog;
        }
        return catelogAll;
    },
    conversionMilliseconds(time) {
        let result = "";   
        var days = Math.floor(time / (1000 * 60 * 60 * 24));
        var hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((time % (1000 * 60)) / 1000);
        if (days) {
            result += days + " d ";
        }
        if (hours) {
            result += hours + " h ";
        }
        if (minutes) {
            result += minutes + " min ";
        }
        result += seconds + " s ";
        return result;
    },
    getEndTime(detail) {
        let startTime;
        if (detail.taskStartTimeStr && detail.taskElaspedTimeLong) {
            startTime = new Date(detail.taskStartTimeStr).getTime();
        } else if (detail.taskStartTimeLong && detail.taskElaspedTimeLong) {
            startTime = detail.taskStartTimeLong;
        } else if(detail.taskStartTime){
            startTime = detail.taskStartTime;
        }else{
            return false;
        }
        let endTime = startTime + detail.taskElaspedTimeLong;
        let date = new Date(endTime);
        let year = date.getFullYear();
        let Month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        if (Month >= 1 && Month <= 9) {
            Month = "0" + Month;
        }
        if (day >= 0 && day <= 9) {
            day = "0" + day;
        }
        if (hour >= 0 && hour <= 9) {
            hour = "0" + hour;
        }
        if (minutes >= 0 && minutes <= 9) {
            minutes = "0" + minutes;
        }
        if (seconds >= 0 && seconds <= 9) {
            seconds = "0" + seconds;
        }
        let dateStr = year + '-' + Month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
        return dateStr;

    },
    //将数字类型的时间转换为英文格式 
    transferForMatTime: function(cTime) {
        if (!cTime) return '';
        var date = new Date(cTime);
        let year = date.getFullYear();
        let Month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        if (Month >= 1 && Month <= 9) {
            Month = "0" + Month;
        }
        if (day >= 0 && day <= 9) {
            day = "0" + day;
        }
        if (hour >= 0 && hour <= 9) {
            hour = "0" + hour;
        }
        if (minutes >= 0 && minutes <= 9) {
            minutes = "0" + minutes;
        }
        if (seconds >= 0 && seconds <= 9) {
            seconds = "0" + seconds;
        }
        let dateStr = year + '-' + Month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
        return dateStr;
        },
           //将数字类型的时间转换为英文格式 
    transferForMatTimeTurn: function(cTime) {
        if (!cTime) return '';
        var date = new Date(cTime);
        let year = date.getFullYear();
        let Month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        if (Month >= 1 && Month <= 9) {
            Month = "0" + Month;
        }
        if (day >= 0 && day <= 9) {
            day = "0" + day;
        }
        if (hour >= 0 && hour <= 9) {
            hour = "0" + hour;
        }
        if (minutes >= 0 && minutes <= 9) {
            minutes = "0" + minutes;
        }
        if (seconds >= 0 && seconds <= 9) {
            seconds = "0" + seconds;
        }
        let dateStr =hour + ':' + minutes + ':' + seconds +' ' +year + '-' + Month + '-' + day;
        return dateStr;
        },
    filterCause(str) {
        var words = str.split(':');
        return words[1];
    },
    encodeModel(model) {
        let Base64 = require('js-base64').Base64;
        return Base64.encode(JSON.stringify(model));
    },
    getAllBytes(itemArr) {
        let allSzie = 0;
        $.each(itemArr, function(index, item) {
            if (item && item.size) {
                allSzie = allSzie + item.size
            }
        });
        return allSzie;
    },
    getStrValue(str) {
        if (!str) {
            return false;
        }
        let dom = document.getElementById('container');
        if (dom) {
            dom.innerHTML = str;
        }
    },
    getStrUpValue(str) {
        let dom = document.getElementById('containerUp');
        if (dom) {
            dom.innerHTML = str;
        }
    },
    getCauseReason(str) {
        let result;
        if (typeof str === 'string') {
            result = str.replace(/.*(Exception:)[ ]*/, "");
          } else if (typeof str === 'object') {
            result = JSON.stringify(str);   
          } else {
            result = str + ""; // 或者根据情况适当处理非字符串情况
          }
        return result;
    }
}
export default filters


// WEBPACK FOOTER //
// ./src/js/filters.js